import React, { FC } from 'react'

const TickIcon: FC = () => {
  return (
    <div>TickIcon</div>
  )
}

export default TickIcon